export default __webpack_public_path__ + "static/media/ic-instruction-05.c82d5f3b.svg";